import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { rootStore, persistor } from "store/configureStore";
import { GoogleOAuthProvider } from "@react-oauth/google";

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="369678056514-q1e322ugb45ffm0fo5hpoku3tqt4s277.apps.googleusercontent.com">
      <Provider store={rootStore}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();

// index.js (client entry)
(function () {
  if (typeof window === 'undefined') return;

  // namespaced object to avoid accidental collisions
  window.__MY_APP_PWA__ = window.__MY_APP_PWA__ || { deferredPrompt: null };

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__MY_APP_PWA__.deferredPrompt = e;
    // notify components
    window.dispatchEvent(new CustomEvent('myapp:pwa-install-available'));
  });

  window.addEventListener('appinstalled', () => {
    window.__MY_APP_PWA__.deferredPrompt = null;
    window.dispatchEvent(new CustomEvent('myapp:pwa-installed'));
  });
})();